import React, { useState, useEffect } from "react";
import DataTable from 'react-data-table-component';
import { makeApiRequest } from "../axiosService/apiCall";

function UserDetails() {
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [countLoading, setCountLoading] = useState(false);

    useEffect(() => {
        getUserDetails();
    }, []);


    const getUserDetails = async () => {
        setCountLoading(true);
        try {
            let params = {
                url: `getRegisterData`,
                method: 'GET',
            };
            let response = await makeApiRequest(params);
            if (response.status === true && response.decryptedUsers) {
                setCountLoading(false);
                setData(response.decryptedUsers);
            } else {
                setCountLoading(false);
                setData([]);
            }
        } catch (error) {
            console.log('error', error);
        }
    };



    const formatISTDate = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    // Filter data based on search query

    const filteredData = data.filter(row => {
        const formattedDate = row.Date ? formatISTDate(row.Date) : "-";
        const phone = row.phoneNumber?.toString() || "";
        const email = row.email?.toLowerCase() || "";
        const kycStatusText = (() => {
            switch (row?.KycStatus) {
                case 0: return "Not Apply";
                case 1: return "Pending";
                case 2: return "Verified";
                case 3: return "Rejected";
                default: return "Unknown";
            }
        })();

        const lowerSearch = searchQuery.toLowerCase();

        return (
            (email && email.includes(lowerSearch)) ||
            phone.includes(lowerSearch) ||
            formattedDate.includes(lowerSearch) ||
            kycStatusText.toLowerCase().includes(lowerSearch)
        );
    });


    // const filteredData = data.filter(row => {
    //     console.log("row---",row);

    //     const formattedDate = row.Date ? formatISTDate(row.Date) : "-";

    //     return (
    //         (row.email && row.email.trim() !== "" && row.email.toLowerCase().includes(searchQuery.toLowerCase())) || row.phoneNumber.includes(searchQuery) ||   formattedDate.includes(searchQuery) 
    //     );

    // });

    const columns = [
        {
            name: 'S.No', width: '80px', selector: (row, index) => index + 1 + (currentPage - 1) * rowsPerPage
            , sortable: true
        },
        { name: 'Date & Time', selector: row => row.Date ? formatISTDate(row.Date) : "-", sortable: true, width: '200px' },
        {

            name: 'Email',
            selector: row => row.email,
            sortable: true,
            width: "350px"
        },
        {

            name: 'Password',
            selector: row => row.password,
            sortable: true,
            width: "300px"
        },
        {
            name: 'ReferralCode',
            selector: row => row.referalCode,
            sortable: true,
            width: "150px"
        },
        {
            name: 'Gender',
            selector: row => row.PersonalDetails?.Gender ? row.PersonalDetails?.Gender : "-",
            sortable: true,
            width: "100px"
        },
        {
            name: 'PhoneNumber',
            selector: row => row.phoneNumber ? row.phoneNumber : "-",
            sortable: true,
            width: "250px"

        },
        {
            name: 'Kyc Status',
            selector: row => {
                switch (row?.KycStatus) {
                    case 0: return "Not Apply";
                    case 1: return "Pending";
                    case 2: return "Verified";
                    case 3: return "Rejected";
                    default: return "Unknown";
                }
            },
            sortable: true,
        }
    ];

    const customSort = (rows, selector, direction) => {
        return rows.sort((a, b) => {
            if (typeof selector(a) === "string") {
                const aField = selector(a).toLowerCase();
                const bField = selector(b).toLowerCase();

                let comparison = 0;

                if (aField > bField) {
                    comparison = 1;
                } else if (aField < bField) {
                    comparison = -1;
                }
                return direction === 'desc' ? comparison * -1 : comparison;
            } else {
                const aField = selector(a).props.children ? parseFloat(selector(a).props.children) : 0;
                const bField = selector(b).props.children ? parseFloat(selector(b).props.children) : 0;
                let comparison = 0;

                if (aField > bField) {
                    comparison = 1;
                } else if (aField < bField) {
                    comparison = -1;
                }
                return direction === 'desc' ? comparison * -1 : comparison;
            }
        });
    };

    return (

        <div className="App">
            <div className="container-fluid">
                <div className="custom-saled-order text-dark" style={{ marginLeft: "15px" }}>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="py-3 d-flex justify-content-between align-items-center mb-2">
                                <div className="d-flex align-items-center">
                                    <h3 className="component-user text-center">User Details</h3>
                                    {countLoading ? (
                                        <button className='refresh-btn ms-3'>
                                            <div class="spinner-border " style={{ width: "20px", height: "20px" }} role="status">
                                                <span class="visually-hidden ">Loading...</span>
                                            </div>
                                        </button>
                                    ) : (
                                        <button
                                            className='refresh-btn fw-bold ms-3'
                                            onClick={getUserDetails}
                                        >
                                            Refresh
                                        </button>
                                    )}
                                </div>

                            </div>
                            <div className='row'>
                                <div className='col-lg-6'>
                                    <input
                                        className="form-control form-search"
                                        type="text"
                                        placeholder="Search by Email, Date, Phone, KYC Status"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="custom-inside-saled-order text-center mt-1">
                                <div className="custom-datascroll">

                                    <DataTable
                                        columns={columns}
                                        data={filteredData}
                                        pagination
                                        persistTableHead
                                        sortFunction={customSort}
                                        paginationPerPage={rowsPerPage}
                                        paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                        onChangePage={(page) => setCurrentPage(page)}
                                        onChangeRowsPerPage={(newPerPage, page) => {
                                            setRowsPerPage(newPerPage);
                                            setCurrentPage(page);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserDetails;
